function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useCallback } from 'react';
import cn from 'classnames';
import { AnimatePresence } from 'framer-motion';
import Link from 'components/Link';
import ButtonLabel from './ButtonLabel';
import ButtonLoader from './ButtonLoader';
import { useInitialProgress } from './hooks';
const Button = ({ id, children, labelMessage, labelMessageValues, styleModifier, type = 'button', to = '', data = {}, isInProgress = false, isDisabled = false, className, onClick = ()=>{}, onClickDisabled })=>{
    const isInitInProgress = useInitialProgress(isInProgress);
    const onClickButton = useCallback((evt)=>{
        const isEnabled = (!isDisabled || !!onClickDisabled) && !isInProgress;
        if (!isEnabled) {
            evt.preventDefault();
            if (isDisabled && onClickDisabled) {
                onClickDisabled(evt);
            }
            return;
        }
        onClick(evt);
    }, [
        isDisabled,
        isInProgress,
        onClick,
        onClickDisabled
    ]);
    const buttonClassName = cn('btn', {
        [`btn--${styleModifier}`]: styleModifier,
        'btn--disabled': isDisabled,
        'btn--in-progress': isInProgress
    }, className);
    const buttonInner = /*#__PURE__*/ _jsxs("span", {
        className: "btn-inner",
        children: [
            /*#__PURE__*/ _jsx(ButtonLabel, {
                labelMessage: labelMessage,
                labelMessageValues: labelMessageValues,
                isInProgress: isInProgress,
                isInitInProgress: isInitInProgress,
                children: children
            }),
            /*#__PURE__*/ _jsx(AnimatePresence, {
                children: isInProgress && /*#__PURE__*/ _jsx(ButtonLoader, {
                    isInitInProgress: isInitInProgress
                })
            })
        ]
    });
    if (type === 'link') {
        const isEnabled = !isDisabled && !isInProgress;
        return /*#__PURE__*/ _jsx(Link, _object_spread_props(_object_spread({
            id: id,
            to: isEnabled ? to : '',
            className: buttonClassName,
            onClick: onClickButton
        }, data), {
            children: buttonInner
        }));
    }
    const isEnabled = (!isDisabled || !!onClickDisabled) && !isInProgress;
    return /* eslint-disable react/button-has-type */ /*#__PURE__*/ _jsx("button", _object_spread_props(_object_spread({
        id: id,
        type: type,
        className: buttonClassName,
        disabled: !isEnabled,
        onClick: onClickButton
    }, data), {
        children: buttonInner
    }));
};
export default /*#__PURE__*/ memo(Button);
